import { z } from 'zod'
import { PaymentInterval } from './PaymentInterval'
import { SwitchTerms } from './TermSwitchPreview'

// A period the plan can change to at its next renewal, priced on the
// account's basis: what one period bills and its monthly equivalent.
export const BillingPeriodOption = z.object({
  billing_freq: PaymentInterval,
  price_cents: z.number(),
  monthly_cents: z.number()
})

export type BillingPeriodOption = z.infer<typeof BillingPeriodOption>

// GET /subscription/{id}/billing-period. effective_at and pending_from are
// Unix seconds; the pending fields are null while no change is scheduled.
export const BillingPeriodState = z.object({
  billing_freq: PaymentInterval,
  effective_at: z.number(),
  options: z
    .array(BillingPeriodOption)
    .nullish()
    .transform((options) => options ?? []),
  pending_billing_freq: PaymentInterval.nullish(),
  pending_from: z.number().nullish(),
  terms: SwitchTerms
})

export type BillingPeriodState = z.infer<typeof BillingPeriodState>
